<script>
export default {
  name: "FormBanner",
  props: {
    value: {
      type: Number,
      default: null
    },
    titulo: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      options: [
        {
          label: "Informativo",
          value: 1,
          icon: "mdi-information",
          color: "blue"
        },
        {
          label: "Advertencia",
          value: 2,
          icon: "mdi-alert",
          color: "orange"
        },
        {
          label: "Crítico",
          value: 3,
          icon: "mdi-alert-octagram",
          color: "red"
        }
      ]
    };
  },
  methods: {
    select(val) {
      this.$emit("input", val); 
      //console.log(val)
    }
  }
};
</script>

<template>
  <div>
    <label class="titleslight--text">{{ titulo }} <span class="titleslight--text font-weight-bold ml-1">*</span></label>
    <v-row class="justify-center">
      <v-col 
      v-for="option in options"
      :key="option.value"
      :cols="'auto'"
      >
        <v-card 
        :outlined="value !== option.value"
        :elevation="value === option.value ? 4 : 0"
        class="pa-4 text-center d-flex flex-column justify-space-between"
        @click="select(option.value)"
        :color="value === option.value ? option.color : ''"
        style="cursor: pointer; width:150px ;">
            <p style="display: inline;">{{option.label}}</p>
          <v-icon
          large
          class="mb-2"
          :color="value === option.value ? 'white' : option.color"
          >
            {{ option.icon }}
          </v-icon>
        </v-card>
      </v-col>  
    </v-row>
  </div>
</template>

